import { render, staticRenderFns } from "./retailMall.vue?vue&type=template&id=f6e0d280&scoped=true"
import script from "./retailMall.vue?vue&type=script&lang=js"
export * from "./retailMall.vue?vue&type=script&lang=js"
import style0 from "./retailMall.vue?vue&type=style&index=0&id=f6e0d280&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6e0d280",
  null
  
)

export default component.exports